import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Home, ShoppingBag, Phone, ArrowRight, Gauge } from 'lucide-react';

const LOGO = 'https://media.base44.com/images/public/69e7659143303e8153678f84/d1f090528_Asset1.png';

export default function NotFound() {
  return (
    <div className="min-h-screen bg-[#0d0d0f] flex flex-col items-center justify-center px-6 py-16 relative overflow-hidden">
      {/* background glow */}
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[120vw] h-[120vw] max-w-[900px] max-h-[900px] rounded-full bg-primary/10 blur-[120px]" />
        <div className="absolute inset-0 carbon-bg opacity-40" />
      </div>

      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
        className="relative z-10 w-full max-w-md text-center"
      >
        <Link to="/" className="inline-block mb-10">
          <img src={LOGO} alt="Motion Reality" className="h-10 md:h-12 w-auto mx-auto brightness-0 invert" />
        </Link>

        {/* 404 with speed lines */}
        <div className="relative mb-8">
          <motion.div
            initial={{ opacity: 0, scale: 0.8 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ delay: 0.15, type: 'spring', stiffness: 200 }}
            className="relative inline-block"
          >
            <h1 className="font-black uppercase leading-none text-primary" style={{ fontSize: 'clamp(6rem, 30vw, 11rem)', letterSpacing: '-0.05em' }}>
              404
            </h1>
            <motion.div
              animate={{ x: [-120, 320], opacity: [0, 1, 0] }}
              transition={{ repeat: Infinity, duration: 2.4, ease: 'easeIn', repeatDelay: 0.6 }}
              className="absolute top-1/2 -translate-y-1/2 left-0 h-[3px] w-24 bg-primary/80 blur-[1px]"
            />
          </motion.div>
        </div>

        <div className="inline-flex items-center gap-2 border border-white/15 bg-white/5 backdrop-blur-sm text-white/70 text-[11px] font-bold tracking-widest px-3 py-1.5 mb-6 uppercase">
          <Gauge className="w-3.5 h-3.5 text-primary" />
          Off Track
        </div>

        <h2 className="text-white font-black text-2xl md:text-3xl uppercase leading-tight mb-3">
          This Page<span className="text-primary"> Spun Out</span>
        </h2>
        <p className="text-white/40 text-sm leading-relaxed mb-9 max-w-xs mx-auto">
          The page you're looking for has taken a pit stop — or never existed. Let's get you back on the racing line.
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-3 gap-2.5">
          <Link to="/">
            <button className="w-full inline-flex items-center justify-center gap-2 bg-primary/20 border border-primary/40 hover:bg-primary hover:border-primary text-white font-bold text-xs tracking-widest px-4 py-3.5 transition-colors">
              <Home className="w-4 h-4" /> HOME
            </button>
          </Link>
          <Link to="/shop">
            <button className="w-full inline-flex items-center justify-center gap-2 bg-primary/20 border border-primary/40 hover:bg-primary hover:border-primary text-white font-bold text-xs tracking-widest px-4 py-3.5 transition-colors">
              <ShoppingBag className="w-4 h-4" /> SHOP
            </button>
          </Link>
          <a href="tel:01515283001">
            <button className="w-full inline-flex items-center justify-center gap-2 bg-primary/20 border border-primary/40 hover:bg-primary hover:border-primary text-white font-bold text-xs tracking-widest px-4 py-3.5 transition-colors">
              <Phone className="w-4 h-4" /> CALL
            </button>
          </a>
        </div>

        <Link to="/contact" className="inline-flex items-center gap-1.5 text-white/40 hover:text-primary text-xs font-bold tracking-widest mt-8 transition-colors">
          OR CONTACT OUR TEAM <ArrowRight className="w-3.5 h-3.5" />
        </Link>
      </motion.div>
    </div>
  );
}